import { isString } from 'lodash';

class UtilsService {
    removeSpaces(value) {
        return isString(value) ? value.trim().replace(/ /g, '') : '';
    }

    formatPhoneNumber(value) {
        return isString(value) ? this.removeSpaces(value).replace(/[()-]|(\+1)/g, '') : '';
    }

    formatPostalCode(value) {
        if (!isString(value)) {
            return '';
        }

        const trimValue = this.removeSpaces(value);
        const zipCodeFirstPart = trimValue.substring(0, 3).toUpperCase();
        const zipCodeLastPart = trimValue.substring(3, 6).toUpperCase();
        const zipCode = `${zipCodeFirstPart} ${zipCodeLastPart}`;

        return trimValue.length > 3 ? zipCode : this.removeSpaces(zipCode);
    }
}

export default new UtilsService();



// WEBPACK FOOTER //
// ./src/services/StringUtilService/StringUtilService.js